import React from 'react';
import { useEditMode } from '../../hooks/useEditMode';
import ReplaceImageButton from '../ReplaceImageButton';
import { StyledImgProps } from '../../dto/StyleCompRepository';
import { DisplayAlignment, DisplaySize } from '../../enum/EnumRepository';
import OptimizedImg from '../OptimizedImg';
import { useObjectUrl } from '../../hooks/useObjectUrl';

interface OptimizedMoleculeImgProps {
  srcUrl: string;
  alt: string;
  displaySize: DisplaySize;
  displayAlignment: DisplayAlignment;
  handleChange: (originUrl: string, width: number, height: number) => void;
  handleFileChange?: (file: File, width: number, height: number) => void;
  imageFile?: File | null;
  StyledImg: React.ComponentType<StyledImgProps>;
  priority: boolean;
  handleOnClick?: () => void;
  imageRatio?: number;
}

const OptimizedMoleculeImg: React.FC<OptimizedMoleculeImgProps> = ({
  srcUrl,
  alt,
  displaySize,
  displayAlignment,
  handleChange,
  handleFileChange,
  imageFile,
  StyledImg,
  priority,
  handleOnClick,
  imageRatio
}) => {
  const { isEditMode } = useEditMode();
  const localImageUrl = useObjectUrl(imageFile);

  return (
    <>
      <OptimizedImg 
      imageUrl={localImageUrl || srcUrl}
      alt={alt} 
      StyledImg={StyledImg} 
      displaySize={displaySize}
      displayAlignment={displayAlignment} 
      priority={priority} 
      handleClick={handleOnClick}
      imageRatio={imageRatio} />
      {isEditMode && (
        <ReplaceImageButton
          setImageUrl={handleChange}
          setImageFile={handleFileChange}
        />
      )}
    </>
  );
}


export default OptimizedMoleculeImg;
